import Aerators from './aerators';
import { Route } from 'types/route.type';

export const routes: Route[] = [
  {
    path: '/self-service/aerators/',
    component: Aerators,
    id: 'selfService.aerators.title',
  },
];
